export default "__VITE_PUBLIC_ASSET__1bccb28a__"